module.exports = __webpack_public_path__ + "media/images/app/testimonials/reviews/GABRIEL TASSLE2-2c309ea80b6c3f5aa0fb6a9fd5488d27.webp";